<template>
  <div id="map"></div>
</template>
<script>
export default {
  name: "meMap",
  props: {
    latLng: {
      type: String,
      default: "116.307503,39.984104",
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.loadScript();
  },
  methods: {
    //动态创建的<script>标签用来引入cdn文件
    loadScript() {
      console.log(this.latLng, "map");
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://map.qq.com/api/gljs?v=1.exp&key=GVUBZ-ZJHCU-NYNVY-4PJAE-E7YO5-7HFBV&callback=init";
      script.onload = script.onreadystatechange = () => {
        if (
          !this.readyState ||
          this.readyState === "loaded" ||
          this.readyState === "complete"
        ) {
          this.initMap();
          script.onload = script.onreadystatechange = null;
        }
      };
      document.body.appendChild(script);
    },
    initMap() {
      console.log(this.latLng);
      let latLng = this.latLng.split(",");
      //定义地图中心点坐标
      var center = new TMap.LatLng(latLng[1], latLng[0]);
      //初始化地图
      var map = new TMap.Map("map", {
        zoom: 15,
        center: center,
      });
      var markerLayer = new TMap.MultiMarker({
        map: map, //指定地图容器
        styles: {
          myStyle: new TMap.MarkerStyle({
            width: 40, // 点标记样式宽度（像素）
            height: 48, // 点标记样式高度（像素）
            src: require("../../assets/image/conaddr.png"), //图片路径
            anchor: { x: 16, y: 32 },
          }),
        },
        //点标记数据数组
        geometries: [
          {
            id: "1", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
            styleId: "myStyle", //指定样式id
            position: new TMap.LatLng(latLng[1], latLng[0]), //点标记坐标位置
            // properties: {
            //自定义属性
            // title: "marker1",
            // },
          },
        ],
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/common/map.vue